import type { OnboardingStore } from "@/domains/auth/onboarding/context/OnboardingContext";
import type { FreelanceBusinessCardData } from "@/domains/freelance/components/business-card/types";
import { parseStringToNumber } from "@/libs/format";

const emptyToUndefined = (value?: string | null) => value || undefined;

/**
 * Snapshots the onboarding store into the data the business card renders.
 *
 * Taken once, at submit time: the success screen keeps showing the profile the
 * user just created even after the store is reset or the profile is refetched.
 * Pure and i18n-free — the card resolves labels and formatting itself.
 */
export const mapOnboardingStoreToBusinessCard = (
  store: OnboardingStore,
): FreelanceBusinessCardData => {
  const pricePerDay = store.pricing.value.price_per_day;
  return {
    fullName: store.profile.full_name,
    avatarUrl: emptyToUndefined(store.info.value.avatar_url),
    jobTitle: store.job_title.value,
    residency: emptyToUndefined(store.info.value.residency),
    skills: [...store.skills.value],
    pricePerDay:
      typeof pricePerDay === "string"
        ? parseStringToNumber(pricePerDay)
        : pricePerDay,
    availabilityNow: store.info.value.is_available ?? false,
    workPreference: store.info.value.work_preference,
  };
};
